export default __webpack_public_path__ + "static/media/instagram-icon.73a3be5d.svg";